// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal-module--overlay--ctrHy","wrapper":"Modal-module--wrapper--C_cxF","modal":"Modal-module--modal--1qsDb","closeButton":"Modal-module--closeButton--3EkSD"};